<template>
  <div class="md-p-4 flex h-12.5 w-full items-center justify-between bg-white p-0 md:hidden">
    <div
      class="flex size-12 cursor-pointer items-center justify-center rounded-full text-gray-500"
      @click="is_menu_open = !is_menu_open"
    >
      <FontAwesomeIcon
        icon="bars"
        size="lg"
      />
    </div>
    <avatar
      :format="current_tenant?.attributes?.picture_logo_format"
      :src="current_tenant?.attributes?.picture_logo_url_s"
      :username="current_tenant?.attributes?.name"
      size="40"
    />
    <TheNotificationsToggleIcon />
  </div>
  <Sidebar v-model="is_menu_open" />
</template>

<script setup>
import { computed, ref } from 'vue';
import Sidebar from '@/app/_customers/components/navbar/TheSidebar.vue';
import { useStore } from 'vuex';
import TheNotificationsToggleIcon from '@/app/shared_components/navbar/notifications/TheNotificationsToggleIcon.vue';

const store = useStore();
const current_tenant = computed(() => store.getters.current_tenant);
const is_menu_open = ref(false);
</script>
